import {
  Body,
  Button,
  H5,
  Stack,
  useModals,
  useWindowProperties,
} from '@qred/components-library';
import React from 'react';
import { useSelector } from 'react-redux';
import { getCardOfferWelcomeSplashImage } from '~/constants/markets';
import useTranslate from '~/hooks/useTranslate';
import { RootState } from '~/store';

const WelcomeModalContent = () => {
  const t = useTranslate();
  const { market } = useSelector((state: RootState) => state.intl);
  const { isMobile } = useWindowProperties();
  const modals = useModals();

  return (
    <Stack>
      <img src={getCardOfferWelcomeSplashImage(market, isMobile)} alt="" />
      <H5>{t('OnboardingCardOffer.WelcomeModalTitle')}</H5>
      <Body size="lg">{t('OnboardingCardOffer.WelcomeModalText')}</Body>
      <Button
        onClick={() => modals.closeAll()}
        ml="auto"
        display="block"
        fullWidth={isMobile}
      >
        {t('OnboardingCardOffer.WelcomeModalButtonText')}
      </Button>
    </Stack>
  );
};

export default WelcomeModalContent;
